<ng-container *ngIf="(assessmentTitle$ | async)" class="h-full flex flex-column">
    <mat-drawer-container [hasBackdrop]="true" class="h-screen relative">
        <mat-drawer #sidenav [mode]="'over'">
            <div class="sidebar-content flex-1 flex flex-column h-full">
                <app-flight-list-filter-sidebar [filterForm]="filterForm" (closeButtonClicked)="sidenav.close()"
                    [statusList]="statusList" [userList]="userList$ | async" [aircraftList]="aircraftList$ | async"
                    [timeFrameList]="timeFrameList" [groupFilterOptions]="groupFilterOptions$ | async">
                </app-flight-list-filter-sidebar>
            </div>
        </mat-drawer>
        <mat-drawer-content class="app-content  h-full overflow-y-auto md:mt-5">
            <app-flight-list-filter-topbar [filterForm]="filterForm" [currentFilters]="currentFilters"
                (filterButtonClicked)="sidenav.open()" [statusList]="statusList" [userList]="userList$ | async"
                [aircraftList]="aircraftList$ | async" [timeFrameList]="timeFrameList"
                [groupFilterOptions]="groupFilterOptions$ | async">
            </app-flight-list-filter-topbar>

            <app-loading-indicator *ngIf="!(stats$ | async); else content">
            </app-loading-indicator>

            <ng-template #content>
                <div *ngIf="!(stats$ | async)?.meta?.results; else stats">
                    <div class="empty-state my-5 mx-auto flex flex-column align-items-center justify-content-center text-center"
                        style="max-width: 400px;">
                        <img class="no-assessment mb-4" id="img-empty-insights" src="/assets/img/empty-insights.svg"
                            alt="No Stats to Display" />
                        <h2 class="mb-3">No Statistics to Display</h2>
                        <p class="mb-0">
                            No statistics available for this assessment yet.
                        </p>
                    </div>
                </div>

                <ng-template #stats>
                    <app-form-type-stats *ngIf="statsData$ | async as stats; else noStatsData" [stats]="stats"
                        [formType]="assessmentId">
                    </app-form-type-stats>

                    <ng-template #noStatsData>
                        <div class="no-stats-message p-4 my-4">
                            <p class="mb-2">No statistics available for this assessment yet.</p>
                        </div>
                    </ng-template>
                </ng-template>
            </ng-template>
        </mat-drawer-content>
    </mat-drawer-container>
</ng-container>